import { Loader } from "@design-system/Loader/Loader";
import { VStack } from "@design-system/VStack/VStack";
import styles from "./StickyTaskMembershipPending.module.scss";

export const StickyTaskMembershipPending = () => (
    <VStack
        align="center"
        justify="center"
        padding={24}
        className={styles.pending}
    >
        <Loader />
    </VStack>
);
